import Switch from '@/components/Switch/Switch';
import styled from '@emotion/styled';

interface FootageSafeZoneToggleProps {
    setSafeZoneEnabled: (isSafeZoneEnabled: boolean) => void;
    isSafeZoneEnabled: boolean;
}

const Container = styled.div`
    margin: 5px 0;
    position: absolute;
    right: 0;
`;

const FootageSafeZoneToggle = ({ isSafeZoneEnabled, setSafeZoneEnabled }: FootageSafeZoneToggleProps) => {
    const handleSwitchToggle = (_: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setSafeZoneEnabled(checked);
    };

    return (
        <Container>
            Safe zone <Switch checked={isSafeZoneEnabled} onChange={handleSwitchToggle} />
        </Container>
    );
};

export default FootageSafeZoneToggle;
